import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { LiveReportList } from '@futrli-sdk/predict';

import { ViewPdfWizardContainer } from './view-pdf-wizard-container';

export interface ViewPdfSidebarData {
  report: LiveReportList;
}

interface ViewPdfSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  report: LiveReportList;
}

export const ViewPdfSidebar = ({ isOpen, onClose, report }: ViewPdfSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        <FormattedMessage id="predict.actions.download_pdf" defaultMessage="Download PDF" />
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <ViewPdfWizardContainer isOpen={isOpen} onClose={onClose} report={report} />
  </Sidebar>
);
